import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import TelagriLogo from 'assets/images/TelagriSingleLogo.png';

export const AuthenticationLoader = () => {
	const { t } = useTranslation();

	return (
		<Box
			position="fixed"
			top={0}
			left={0}
			width="100%"
			height="100%"
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			bgcolor="rgba(255, 255, 255, 0.95)"
			zIndex={9999}
			sx={{
				backdropFilter: 'blur(3px)',
			}}
		>
			{/* Logo with pulsing animation */}
			<Box
				sx={{
					mb: 3,
					animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
					'@keyframes pulse': {
						'0%, 100%': {
							opacity: 1,
						},
						'50%': {
							opacity: 0.7,
						},
					},
				}}
			>
				<img 
					src={TelagriLogo} 
					alt="TelAgri Logo" 
					style={{ 
						width: '80px', 
						height: '80px',
						objectFit: 'contain',
						borderRadius: '12px'
					}} 
				/>
			</Box>

			{/* Loading spinner */}
			<CircularProgress 
				size={40} 
				thickness={4}
				sx={{ 
					color: '#038877',
					mb: 2
				}} 
			/>

			{/* Loading text */}
			<Typography 
				variant="body1" 
				sx={{ 
					color: '#666',
					fontSize: '16px',
					fontWeight: 500,
					textAlign: 'center',
					maxWidth: '300px',
					lineHeight: 1.5
				}}
			>
				{t('authenticationLoader.checking', 'Checking authentication...')}
			</Typography>

			{/* Subtitle */}
			<Typography 
				variant="body2" 
				sx={{ 
					color: '#999',
					fontSize: '14px',
					textAlign: 'center',
					mt: 1,
					maxWidth: '250px'
				}}
			>
				{t('authenticationLoader.pleaseWait', 'Please wait a moment')}
			</Typography>
		</Box>
	);
}; 